<template>
  <div>
    <!-- Overlay -->
    <div 
      v-if="isOpen" 
      class="sidebar-overlay" 
      @click="$emit('close')"
    ></div>
    
    <!-- Sidebar -->
    <div class="mobile-sidebar" :class="{ 'sidebar-open': isOpen }">
      <div class="sidebar-header">
        <h3>{{ $t('app.name') }}</h3>
        <button @click="$emit('close')" class="close-btn">
          <span>&times;</span>
        </button>
      </div>
      
      <div class="sidebar-content">
        <nav class="sidebar-nav">
          <button v-if="isLoggedIn" @click="handleUpload" class="sidebar-item upload-btn">
            <span class="sidebar-icon">
              <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
              </svg>
            </span>
            <span>{{ $t('upload.title') }}</span>
          </button>

          <div class="sidebar-item language-item">
            <span class="sidebar-icon">
              <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.9,17.39C17.64,16.59 16.89,16 16,16H15V13A1,1 0 0,0 14,12H8V10H10A1,1 0 0,0 11,9V7H13A2,2 0 0,0 15,5V4.59C17.93,5.77 20,8.64 20,12C20,14.08 19.2,15.97 17.9,17.39M11,19.93C7.05,19.44 4,16.08 4,12C4,11.38 4.08,10.78 4.21,10.21L9,15V16A2,2 0 0,0 11,18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"/>
              </svg>
            </span>
            <div class="language-wrapper">
              <span class="language-label">{{ $t('nav.language') }}</span>
              <LanguageSwitcher variant="mobile" />
            </div>
          </div>

          <button v-if="isLoggedIn" @click="handleLogout" class="sidebar-item logout-btn">
            <span class="sidebar-icon">
              <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17,7L15.59,8.41L18.17,11H8V13H18.17L15.59,15.59L17,17L22,12L17,7M4,5H12V3H4A2,2 0 0,0 2,5V19A2,2 0 0,0 4,21H12V19H4V5Z"/>
              </svg>
            </span>
            <span>{{ $t('nav.logout') }}</span>
          </button>

          <button v-else @click="handleLogin" class="sidebar-item login-btn">
            <span class="sidebar-icon">
              <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                <path d="M10,17V14H3V10H10V7L15,12L10,17M10,2H19A2,2 0 0,1 21,4V20A2,2 0 0,1 19,22H10A2,2 0 0,1 8,20V18H10V20H19V4H10V6H8V4A2,2 0 0,1 10,2Z"/>
              </svg>
            </span>
            <span>{{ $t('nav.login') }}</span>
          </button>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageSwitcher from './LanguageSwitcher.vue'

export default {
  name: 'MobileSidebar',
  components: {
    LanguageSwitcher
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    isLoggedIn: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'upload', 'logout', 'login'],
  methods: {
    handleUpload() {
      this.$emit('upload')
      this.$emit('close')
    },
    handleLogout() {
      this.$emit('logout')
      this.$emit('close')
    },
    handleLogin() {
      this.$emit('login')
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

.mobile-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 280px;
  height: 100vh;
  background: rgba(10, 10, 25, 0.97);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-right: 1px solid rgba(255, 255, 255, 0.07);
  box-shadow: 2px 0 32px rgba(0, 0, 0, 0.5);
  z-index: 9999;
  transform: translateX(-100%);
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
}

.mobile-sidebar.sidebar-open {
  transform: translateX(0);
}

.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  background: transparent;
}

.sidebar-header h3 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  background: linear-gradient(90deg, #00c6ff, #0072ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.close-btn {
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.5);
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

.sidebar-content {
  flex: 1;
  padding: 1rem;
}

.sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.sidebar-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  border: none;
  background: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.75);
  text-align: left;
  width: 100%;
}

.sidebar-item:hover {
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
  transform: translateX(4px);
}

.sidebar-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.75);
  flex-shrink: 0;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar-icon svg {
  width: 20px;
  height: 20px;
  transition: all 0.2s ease;
}

.sidebar-item:hover .sidebar-icon {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.25);
  color: #fff;
}

.language-item {
  cursor: default;
}

.language-item:hover {
  transform: none;
}

.language-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.language-label {
  font-weight: 500;
}

/* Hide sidebar on desktop */
@media (min-width: 1025px) {
  .mobile-sidebar {
    display: none;
  }
  
  .sidebar-overlay {
    display: none;
  }
}

</style> 